import { SET_PROFILE } from '../types/profile';

export const setProfile = (profile) => {
  return {
    type: SET_PROFILE,
    payload: profile
  };
};
